import { Component, inject, Signal, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MessagesService } from '@services/messages/messages.service';
import { TranslateModule } from '@ngx-translate/core';
import { MaterialModule } from '@app/material.module';
import { TablerIconsModule } from 'angular-tabler-icons';

@Component({
  selector: 'app-messages',
  imports: [CommonModule, TranslateModule, MaterialModule, TablerIconsModule],
  templateUrl: './messages.component.html',
  standalone: true,
  styleUrl: './messages.component.scss'
})
export class MessagesComponent {
  private messageService: MessagesService = inject(MessagesService);
  isVisible: Signal<boolean> = this.messageService.isVisible;
  title: Signal<string> = computed(() => `alert.${this.messageService.title()}`);
  messageContent: Signal<string> = computed(() => `alert.${this.messageService.messageContent()}`);
  type: Signal<string> = this.messageService.type;
  icon: Signal<string> = this.messageService.icon;
}